import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HttpError = /*#__PURE__*/function (_Error) {
  function HttpError(_ref) {
    var _this;
    var message = _ref.message,
      statusCode = _ref.statusCode,
      path = _ref.path,
      method = _ref.method,
      xRequestId = _ref.xRequestId,
      headers = _ref.headers;
    _classCallCheck(this, HttpError);
    _this = _callSuper(this, HttpError);
    _this.name = 'HttpError';
    _this.message = message;
    var p = path.split('?')[0];
    _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    _this.method = method;
    _this.statusCode = statusCode;
    _this.xRequestId = xRequestId;
    // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
    // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
    _this.headers = Array.from(headers.entries()).map(function (value, key) {
      return "".concat(key, ":").concat(value);
    }).sort().join(',');
    return _this;
  }
  _inherits(HttpError, _Error);
  return _createClass(HttpError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { HttpError as default };
export var isHttpError = function isHttpError(e) {
  return e instanceof HttpError;
};